'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapStateToProps = mapStateToProps;
exports.PersonalBox = PersonalBox;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _Dropdown = require('../components/Dropdown');

var _Dropdown2 = _interopRequireDefault(_Dropdown);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function NonMemberBox(_ref) {
  var i18n = _ref.i18n,
      urls = _ref.urls;

  return _react2.default.createElement(
    'li',
    { className: 'account', id: 'nonMemberHeader' },
    _react2.default.createElement(
      'div',
      { className: 'nav-tile nav-link' },
      _react2.default.createElement(
        'a',
        { href: urls.external.bookingSignin },
        ' ',
        _react2.default.createElement('span', { className: 'icon-account' }),
        ' '
      ),
      _react2.default.createElement(
        'a',
        { href: urls.external.bookingSignin, className: 'nav-label' },
        i18n.header.myBookings
      )
    )
  );
}
// components
// PersonalBox

NonMemberBox.propTypes = {
  i18n: _react.PropTypes.object.isRequired,
  urls: _react.PropTypes.object.isRequired
};

function SignInBox(_ref2) {
  var urls = _ref2.urls;

  // XXX: currently this is only needed for travel.rakuten.com.tw
  return _react2.default.createElement(
    _Dropdown2.default,
    { className: 'account', id: 'SignInStyle', style: { borderRight: 0 } },
    _react2.default.createElement(
      'div',
      { 'data-role': 'dropdown', 'data-position': 'right,bottom', className: 'nav-tile' },
      _react2.default.createElement('span', { className: 'icon-account' }),
      _react2.default.createElement(
        'span',
        { className: 'nav-label' },
        '\u767B\u5165\u6216\u8A3B\u518A'
      )
    ),
    _react2.default.createElement(
      'div',
      { 'data-role': 'dropdown-content', className: 'nav-tile-content' },
      _react2.default.createElement(
        'ul',
        { className: 'list-block' },
        _react2.default.createElement(
          'li',
          null,
          _react2.default.createElement(
            'a',
            { href: urls.external.signin },
            '\u767B\u5165'
          )
        ),
        _react2.default.createElement(
          'li',
          null,
          _react2.default.createElement(
            'a',
            { href: urls.external.register },
            '\u8A3B\u518A'
          )
        ),
        _react2.default.createElement(
          'li',
          null,
          _react2.default.createElement(
            'a',
            { href: urls.external.bookingSignin },
            '\u6211\u7684\u9810\u8A02'
          )
        )
      )
    )
  );
}

SignInBox.propTypes = {
  urls: _react.PropTypes.object.isRequired
};

function MemberBox(_ref3) {
  var urls = _ref3.urls,
      auth = _ref3.auth,
      i18n = _ref3.i18n;

  // XXX: currently this is only needed for travel.rakuten.com.tw
  return _react2.default.createElement(
    _Dropdown2.default,
    { className: 'account', id: 'userStyle', style: { borderRight: 0 } },
    _react2.default.createElement(
      'div',
      { 'data-role': 'dropdown', 'data-position': 'right,bottom', className: 'nav-tile' },
      _react2.default.createElement('span', { className: 'icon-account' }),
      _react2.default.createElement(
        'span',
        { className: 'nav-label', id: 'userName' },
        '\u60A8\u597D, ',
        auth.username
      )
    ),
    _react2.default.createElement(
      'div',
      { 'data-role': 'dropdown-content', className: 'nav-tile-content for-member' },
      _react2.default.createElement(
        'div',
        { className: 'account-with-points' },
        _react2.default.createElement(
          'a',
          { href: urls.external.point, target: '_blank', rel: 'noreferrer noopener', id: 'pointClub' },
          _react2.default.createElement(
            'div',
            { className: 'left' },
            _react2.default.createElement(
              'span',
              { id: 'userName' },
              '\u60A8\u597D, ',
              auth.username
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'right' },
            _react2.default.createElement(
              'span',
              { className: 'downPoint' },
              new Intl.NumberFormat(i18n.lang.replace('_', '-')).format(Number(auth.totalPoint))
            ),
            ' \u9EDE\u6578'
          )
        )
      ),
      _react2.default.createElement(
        'div',
        { className: 'title' },
        'Manage'
      ),
      _react2.default.createElement(
        'ul',
        { className: 'list-block' },
        _react2.default.createElement(
          'li',
          null,
          _react2.default.createElement(
            'a',
            { href: urls.external.myBooking },
            '\u6211\u7684\u9810\u8A02'
          )
        ),
        _react2.default.createElement(
          'li',
          null,
          _react2.default.createElement(
            'a',
            { href: urls.external.myPage },
            '\u6703\u54E1\u8CC7\u6599'
          )
        ),
        _react2.default.createElement(
          'li',
          null,
          _react2.default.createElement(
            'a',
            { href: urls.external.bookingSignin },
            '\u7BA1\u7406\u55AE\u500B\u9810\u8A02'
          )
        ),
        _react2.default.createElement(
          'li',
          null,
          _react2.default.createElement(
            'a',
            { href: urls.external.signout },
            '\u767B\u51FA'
          )
        )
      )
    )
  );
}

MemberBox.propTypes = {
  urls: _react.PropTypes.object.isRequired,
  auth: _react.PropTypes.object.isRequired,
  i18n: _react.PropTypes.object.isRequired
};

function mapStateToProps(state) {
  return {
    i18n: state.i18n,
    urls: state.urls,
    auth: state.auth,
    isMobile: state.httpRequest.req.useragent.isMobile
  };
}

function PersonalBox(_ref4) {
  var i18n = _ref4.i18n,
      urls = _ref4.urls,
      auth = _ref4.auth,
      isMobile = _ref4.isMobile;

  // XXX: currently this is only needed for travel.rakuten.com.tw
  var component = i18n.lang !== 'zh_TW' ? _react2.default.createElement(NonMemberBox, { i18n: i18n, urls: urls }) : !auth || !auth.username ? _react2.default.createElement(SignInBox, { urls: urls }) : _react2.default.createElement(MemberBox, { urls: urls, auth: auth, isMobile: isMobile, i18n: i18n });
  return component;
}

PersonalBox.propTypes = {
  i18n: _react.PropTypes.object.isRequired,
  urls: _react.PropTypes.object.isRequired,
  auth: _react.PropTypes.object
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(PersonalBox);


//////////////////
// WEBPACK FOOTER
// ./src/containers/PersonalBox.js
// module id = 1239
// module chunks = 0